import styled, { css } from 'styled-components'
import { theme } from '@elamajs/ui-kit'

export const ContentBlock = styled.div`
  display: flex;
  background: #f5f7ff;
  border-radius: 2rem;
  @media (max-width: 1279px) {
    flex-direction: column;
  }

  @media (max-width: 767px) {
    padding: 3rem 1.5rem 6rem 1.5rem;
    border-radius: 0;
  }
`
export const MobileTitle = styled.h3`
  display: none;

  @media (max-width: 767px) {
    && {
      display: block;
      font-size: 2rem;
      line-height: 2.6rem;
      margin-bottom: 2rem;
    }
  }
`

export const Info = styled.div`
  display: flex;
  width: 45.5rem;
  padding: 4rem 0 4rem 4rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;

  @media (max-width: 1279px) {
    padding: 4rem 4rem 1rem 4rem;
    width: 100%;
  }

  @media (max-width: 767px) {
    padding: 0;
    order: 3;
    margin-top: 1rem;
    > h3 {
      display: none;
    }
  }
`

export const Calculations = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
`

export const Calculation = styled.div`
  display: flex;
  padding: 1rem 2rem;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-radius: 1.5rem;
  background: white;

  &:first-child {
    padding: 0.5rem 1.5rem;
  }
`

export const Label = styled.p`
  color: #292e3d;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.4rem;

  @media (max-width: 767px) {
    max-width: 14.5rem;
  }
`

export const Value = styled.p`
  color: #292e3d;
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-size: 2.4rem;
  font-weight: 400;
  line-height: 3rem;
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
`

export const Text = styled.p`
  color: #667399;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
`

export const LinkBlock = styled.div`
  display: flex;
  gap: 1rem;

  &:hover {
    color: #6b8bfa;
    transition: color 0.1s ease-out;
  }
`

export const Calculator = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1rem 1rem 2rem;
  gap: 1rem;
  flex: 1;

  @media (max-width: 1279px) {
    width: 100%;
    padding: 1rem 2rem 2rem 2rem;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 1rem 0 0 0;
  }

  > label {
    max-width: 100%;
  }
`

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 40rem;
`

export const SystemsContainer = styled.div`
  display: flex;
  max-width: 67.5rem;
  width: 100%;
  height: 41rem;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
  border-radius: 1rem;
  border: 1px solid #ced8fd;
  background: white;
  overflow-y: auto;

  @media (max-width: 1279px) {
    max-width: 100%;
  }
`

export const SystemSliderContainer = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 0;
  }
`

export const SystemSliderInfoWrapper = styled.div``

export const SystemSliderTitle = styled.p`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #292e3d;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.4rem;
  margin: 0;
`

export const SystemLogo = styled.img`
  width: 4rem;
  height: 4rem;
`

export const SystemSliderTextContainer = styled.div`
  margin: 0.5rem 0 0 0;
`

export const SystemSliderAdditionalText = styled.div`
  color: #292e3d;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 2rem;
  margin-left: 4rem;
`

export const SystemSliderAdditionalTooltip = styled.div`
  color: #667399;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
  margin-left: 4rem;
`

export const Tooltip = styled.div`
  display: inline-block;

  svg {
    color: #667399 !important;
  }
`

export const TooltipContent = styled.div`
  color: #667399;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.8rem;
`

export const SystemSliderAdditionalError = styled.p`
  display: block;
  font-size: 1.2rem;
  line-height: 1.8rem;
  color: #fb606d;
  margin: 0;

  @media (max-width: 1279px) {
    width: 14rem;
  }

  @media (max-width: 999px) {
    width: 100%;
  }
`

export const SystemSlider = styled.div`
  margin: 1rem 0 0;
  display: flex;
  gap: 4rem;
  max-width: 36.5rem;
  width: 100%;

  div[class^='Sliderstyled__Track'] {
    background-color: #edeff3;
  }

  div[class^='Sliderstyled__TrackFill'] {
    background-color: #3a64f8;
  }

  div[class^='Sliderstyled__SliderInner'] {
    width: 27rem;
    min-width: 27rem;
  }

  span[class^='Sliderstyled__Range'] {
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 400;
  }

  @media (max-width: 767px) {
    flex-wrap: wrap;
    gap: 2rem;

    div[class^='Sliderstyled__SlideWrap'] {
      gap: 0.4rem;
    }
  }

  @media (min-width: 768px) {
    div[class^='Sliderstyled__SliderInner'] {
      width: 30.6rem;
      min-width: 30.6rem;
    }

    div[class^='Sliderstyled__Marks'] {
      div:last-child {
        font-size: 1.2rem;
      }
    }
  }

  @media (min-width: 1000px) {
    margin: 0;

    div[class^='Sliderstyled__SliderWrapper'] {
      display: none;
    }
  }
`
export const Slider = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`

export const SystemTurnoverWrapper = styled.div`
  position: relative;

  input {
    height: 5rem;
    font-family: Navigo, Arial, Helvetica, sans-serif;
    border-color: #c2c7d6;
    font-size: 1.4rem;
    line-height: 2rem;
    border-radius: 0.5rem;
  }

  div[class^='InputCurrencystyled__Wrapper'] {
    height: 5rem;
  }
  div[class^='InputCurrencystyled__CurrencySymbol'] {
    height: 5rem;
    font-family: Navigo, Arial, Helvetica, sans-serif;
    font-size: 1.4rem;
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;
    gap: 2rem;
    width: 100%;
  }
`

export const SystemTurnoverText = styled.div<{ sliderOffset: boolean }>`
  font-size: 1.2rem;
  line-height: 1.8rem;
  color: ${theme.palette.black[50]};
  text-align: right;
  padding-right: 1.5rem;
  white-space: nowrap;
  position: absolute;

  right: 0;

  ${({ sliderOffset }) => {
    if (sliderOffset) {
      return css`
        top: -5.5rem;
      `
    }

    return css`
      top: -4rem;
    `
  }};

  @media (max-width: 767px) {
    position: static;
    padding-right: 0;
  }
`

export const MultiSelect = styled.div`
  width: 100%;

  label[class^='ViewDefaultstyled__DefaultLabel'] {
    max-height: 50px;
    height: 50px;
    padding: 15px 35px 15px 18px;
    border-radius: 1rem;
    max-width: 100%;
  }

  span[class^='SelectWrapperstyled__Label'] {
    font-size: 14px;
    line-height: 20px;
  }

  div[class^='Popupstyled__Popup'] {
    z-index: 1000;
  }

  @media (max-width: 767px) {
    width: 100%;

    div[class^='Popupstyled__ContentWrapper'] {
      width: 25rem;
    }
  }
`
export const CalculationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  background-color: white;
  border-radius: 1.5rem;
  padding: 0.5rem;
`

export const ProgressBarLabel = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  > p {
    color: #292e3d;
    font-family: 'Navigo', Arial, Helvetica, sans-serif;
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 1.8rem;
    margin: 0;
  }
`

export const ProgressBarTrack = styled.div`
  position: relative;
  width: 100%;
  height: 3.8rem;
  overflow: hidden;
  display: flex;
  padding: 1rem 1.5rem;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  background: #ebeffe;
  border-radius: 1rem;
`

export const ProgressBarFill = styled.div<{ percent: number }>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: #ced8fd;
  width: ${({ percent }) => Math.min(percent, 100)}%;
  transition: width 0.3s ease-out;
  z-index: 1;
`

export const ResultError = styled.div`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: #fb606d;
  margin: 10px 0 0;
`

export const PercentageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`

export const PercentageValue = styled.span<{ isActive: boolean }>`
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 2rem;
  color: ${({ isActive }) => (isActive ? '#292e3d' : '#adb5cc')};
  transition: color 0.15s ease-out;
`
